import { Controller } from "@hotwired/stimulus"

// ファイルを選んだ時点で送信し、解析が終わるまで待ちの状態を出す。
// 解析は実測で6〜9秒かかり、無反応だと利用者が連打する。連打すると
// GCSへの多重アップロードと解析APIの多重呼び出しが起きるため、送信後は入力を止める。
export default class extends Controller<HTMLFormElement> {
  static targets = ["input", "idle", "busy"]
  declare readonly inputTargets: HTMLInputElement[]
  declare readonly idleTargets: HTMLElement[]
  declare readonly busyTargets: HTMLElement[]

  private submitting = false

  submit() {
    if (this.submitting) return
    if (this.inputTargets.some((input) => input.files?.length === 0)) return

    // disabled にした入力は送信されないため、ここでは無効化しない。
    // 二重送信は submitting フラグと、ラベルのクリック無効化で防ぐ。
    this.submitting = true
    this.idleTargets.forEach((element) => (element.hidden = true))
    this.busyTargets.forEach((element) => (element.hidden = false))
    this.element.querySelectorAll("label").forEach((label) => (label.style.pointerEvents = "none"))
    this.element.requestSubmit()
  }
}
